export const container = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
};
export const divider = {
  marginTop: 1
};
export const titleContainer = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%'
};
